import { useAppSelector } from "../app/hooks";
import { selectBooking } from "../features/booking/bookingSlice";
import { formatDateLong } from "../helpers/date";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Calendar from "./Svg/Calendar";

export function DateCart() {
  const booking = useAppSelector(selectBooking);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      {booking.EndUtc !== null && booking.Error === null && (
        <div className="bg-custom-100 rounded-xl text-black p-4 flex justify-between items-center mb-4">
          <div>
            {` ${booking.NightCount} ${t("scenes.night", { count: booking.NightCount })} `}{" "}
            <span className={`text-fluid-sm`}>
              ({formatDateLong(booking.StartUtc, false)}
              {" - "}
              {formatDateLong(booking.EndUtc, false)})
            </span>
          </div>
          <div
            className="p-2 bg-custom-200 rounded-md self-start cursor-pointer"
            onClick={() => navigate("/calendar")}
          >
            <Calendar className="size-4 text-black" />
          </div>
        </div>
      )}
    </>
  );
}
